export default [
  {
    path: '/link-manage',
    name: 'link-manage',
    component: resolve => require(['views/link-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/link-form/:id/:isEdit',
    name: 'link-form',
    component: resolve => require(['views/link-form'], resolve),
    meta: { auth: true, view: 'pc' }
  }
]
